import { Fragment } from "react";
import Carousel from "react-material-ui-carousel";
import Fade from "react-reveal/Fade";
import { IProps } from "../../types/CommonTypes";
import { getImageById } from "../../commons/constants/helpers";
import VideoItem from "../videos/VideoItem";
import SectionHeader from "../landing/SectionHeader";
import "../landing/landing.css";

// La Milagrosa (@lamilagrosacol): mesa de análisis político en la que Daniel
// Briceño se sienta junto a Carlos Ayala, Jerome Sanabria, Mateo Ayala y
// Damarix Pabón.
// Los episodios se administran desde el dashboard (website.contact.videos).
const CANAL = "https://www.youtube.com/@lamilagrosacol";
const MESA = [
	"Daniel Briceño",
	"Carlos Ayala",
	"Jerome Sanabria",
	"Mateo Ayala",
	"Damarix Pabón",
];

const Podcast = ({ item }: IProps) => {
	const videos = item.videos ?? [];

	return (
		<section
			id="podcast"
			className="ld-pod"
			style={{
				backgroundImage: `url(${getImageById("banner", item)})`,
			}}
		>
			<div className="ld-pod-overlay" />

			<div
				className={`ld-container ld-pod-grid ${
					videos.length ? "" : "ld-pod-solo"
				}`}
			>
				<div>
					<SectionHeader eyebrow="Pódcast" title="La Milagrosa" light />

					<p className="ld-pod-lead">
						La mesa donde Daniel Briceño desarma la coyuntura con documentos,
						cifras y nombres propios. Episodios completos, sin recortes de
						treinta segundos.
					</p>

					<p className="ld-pod-mesa-label">En la mesa</p>
					<p className="ld-pod-mesa">
						{MESA.map((nombre, index) => (
							<Fragment key={nombre}>
								{index > 0 && <span aria-hidden="true"> · </span>}
								<span className={index === 0 ? "ld-pod-host" : undefined}>
									{nombre}
								</span>
							</Fragment>
						))}
					</p>

					<a
						className="ld-btn ld-btn-yellow"
						href={CANAL}
						target="_blank"
						rel="noopener noreferrer"
					>
						Ver todos los episodios
					</a>
				</div>

				{videos.length > 0 && (
					<Fade bottom duration={800}>
						<div className="ld-pod-player">
							<Carousel
								animation="slide"
								autoPlay={false}
								navButtonsAlwaysInvisible
								indicatorContainerProps={{
									style: {
										position: "relative",
										zIndex: 2,
										marginTop: "16px",
									},
								}}
								indicatorIconButtonProps={{
									style: {
										color: "rgba(255,255,255,0.45)",
										padding: "4px",
									},
								}}
								activeIndicatorIconButtonProps={{
									style: { color: "#FFD400" },
								}}
							>
								{videos.map((video, index) => (
									<VideoItem
										key={index}
										url={video.url}
										title={video.title}
									/>
								))}
							</Carousel>
						</div>
					</Fade>
				)}
			</div>
		</section>
	);
};

export default Podcast;
